<div [class.beta-property-content]="isBetaAccessPrivilegeConsumable">
  <form>
    <div class="table-header property-header">
      <div class="table-title header">
        <img src="assets\images\svg\icon_properties.svg" class="icon-style" alt="properties" />
        <div class="header" [pTooltip]="selectedPropertyTitle" tooltipPosition="top">{{ selectedPropertyTitle }}</div>
        <i class="pi qv-title-error-icon"
           [ngClass]="{
             'pi-exclamation-circle': getQvValidation('queryValidation') || getQvValidation('paramValidation')
           }"
           *ngIf="formData?.qvIsError && formData?.qvErrorMessages"
           [pTooltip]="'CLICK_TO_OPEN_TABLE_VALIDATION_ERRORS' | translate"
           tooltipPosition="bottom"
           (click)="onQvErrorIconClick($event)"
           (keydown.enter)="onQvErrorIconClick($event)"
           tabindex="0"
           role="button"
           aria-label="Open table validation errors"></i>
      </div>

      <div class="formgroup-inline searchbox-button">
        <div class="field">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
            <input
              type="text"
              pInputText
              placeholder="Search"
              [(ngModel)]="searchTerm"
              name="searchTerm"
              [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
            />
            <span
              class="p-inputgroup-addon"
              *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
              (click)="clearFilter()"
              (keyup.enter)="clearFilter()"
              tabindex="0"
              aria-label="Clear filter"
              ><i class="pi pi-times"></i
            ></span>
          </div>
        </div>
      </div>

      <!-- <div class="p-input-icon-left properties-search-container"
        [ngClass]="{'ml-auto':currentPage?.currentPage == 'templates'}">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" [(ngModel)]="searchTerm" name="searchTerm"
          [ngModelOptions]="{standalone: true,updateOn:'change'}" />
        <span *ngIf="searchTerm != '' && searchTerm != undefined" class="input-clear-icon" (click)="clearFilter()"><img
            src="assets\images\svg\icon_clear.svg" /></span>
      </div> -->

      <p-splitbutton
        appendTo="body"
        (onDropdownClick)="getMenuOptions('resetAll')"
        *ngIf="currentPage?.currentPage === 'templates' && !disallowEdit"
        class="property-pane-action-icon ml-2"
        [model]="menuItems"
      >
      </p-splitbutton>
    </div>
    <div class="property-content" [class.beta-property-content]="isBetaAccessPrivilegeConsumable" *ngIf="selectedPropertyTitle !== '' && (propertyPaneBasicData$ | async)">
      @if (isBetaAccessPrivilegeConsumable) {
        <ng-container
          *ngTemplateOutlet="propertiesTemplate; context: { properties: propertyPaneBasicData$ | async }"
        >
        </ng-container>
      } @else {
        <p-accordion [multiple]="true" [value]="0" [transitionOptions]="'300ms cubic-bezier(0.4, 0, 0.2, 1)'">
          <p-accordion-panel
            [value]="0"
            class="props-accord basic-section"
            *ngIf="(propertyPaneBasicData$ | async).length"
          >
            <p-accordion-header></p-accordion-header>
            <p-accordion-content>
              <ng-container
                *ngTemplateOutlet="propertiesTemplate; context: { properties: propertyPaneBasicData$ | async }"
              >
              </ng-container>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      }
    </div>
  </form>
  <!-- The template to load the basic and advanced properties -->
  <ng-template #propertiesTemplate let-properties="properties">
    @if (isBetaAccessPrivilegeConsumable) {
      <p-accordion
        [multiple]="true"
        [value]="betaExpandedGroups"
        (valueChange)="onBetaAccordionValueChange($event)"
        class="beta-properties-accordion"
        [transitionOptions]="'300ms cubic-bezier(0.4, 0, 0.2, 1)'"
      >
        <ng-container *ngFor="let property of properties | uiFilter: searchTerm : ['title', 'groupName']; let j = index">
          <ng-container *ngIf="property?.type === 'group'">
            <ng-container
              *ngFor="
                let groupedProperty of property.items | uiFilter: searchTerm : ['title', 'groupName'] : true;
                let i = index
              "
            >
              <p-accordion-panel
                [value]="property.groupName"
                *ngIf="
                  property.items.length > 0 &&
                  conditionalCheck['showGroups'] &&
                  conditionCheckGp[property.groupName] &&
                  i === 0 &&
                  (groupedProperty.uiType !== 'searchablefields' ||
                    (groupedProperty.uiType === 'searchablefields' && techStackData?.textSearch === 'Elastic Search')) &&
                  !(isFromModernize && property.groupName === 'Page Variables')
                "
              >
                <p-accordion-header>
                  <span class="properties-group-name beta-group-name" [ngClass]="{ 'border-0': j === 0 && hideBasic }">
                    {{ property.groupName }}
                    <i
                      class="fa fa-info-circle field-info"
                      showDelay="100"
                      hideDelay="100"
                      tooltipPosition="bottom"
                      tooltipStyleClass="label-tooltip custom-tooltip-properties"
                      pTooltip="{{ 'QUERY_PARAM_MAP_INFO' | translate }}"
                      *ngIf="property.groupName === 'Parameter Mapping'"
                    ></i>
                  </span>
                </p-accordion-header>
                <p-accordion-content>
                  <ng-container
                    *ngFor="
                      let contentProperty of property.items | uiFilter: searchTerm : ['title', 'groupName'] : true
                    "
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        propertyTemplate;
                        context: { property: contentProperty, propertyGroup: property.items }
                      "
                    >
                    </ng-container>
                  </ng-container>
                </p-accordion-content>
              </p-accordion-panel>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="property?.type !== 'group'">
            <ng-container *ngTemplateOutlet="propertyTemplate; context: { property }"> </ng-container>
          </ng-container>
        </ng-container>
      </p-accordion>
    } @else {
    <ng-container *ngFor="let property of properties | uiFilter: searchTerm : ['title', 'groupName']; let j = index">
      <ng-container *ngIf="property?.type === 'group'">
        <ng-container
          *ngFor="
            let groupedProperty of property.items | uiFilter: searchTerm : ['title', 'groupName'] : true;
            let i = index
          "
        >
          <div
            class="properties-group-name"
            *ngIf="
              property.items.length > 0 &&
              conditionalCheck['showGroups'] &&
              conditionCheckGp[property.groupName] &&
              i === 0 &&
              (groupedProperty.uiType !== 'searchablefields' ||
                (groupedProperty.uiType === 'searchablefields' && techStackData?.textSearch === 'Elastic Search')) &&
              !(isFromModernize && property.groupName === 'Page Variables')
            "
            [ngClass]="{ 'border-0': j === 0 && hideBasic }"
          >
            {{ property.groupName }}
            <i
              class="fa fa-info-circle field-info"
              showDelay="100"
              hideDelay="100"
              tooltipPosition="bottom"
              tooltipStyleClass="label-tooltip custom-tooltip-properties"
              pTooltip="{{ 'QUERY_PARAM_MAP_INFO' | translate }}"
              *ngIf="property.groupName === 'Parameter Mapping'"
            ></i>
          </div>
          <ng-container
            *ngTemplateOutlet="propertyTemplate; context: { property: groupedProperty, propertyGroup: property.items }"
          >
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="property?.type !== 'group'">
        <ng-container *ngTemplateOutlet="propertyTemplate; context: { property }"> </ng-container>
      </ng-container>
    </ng-container>
    }
  </ng-template>
  <ng-template #propertyTemplate let-property="property" let-propertyGroup="propertyGroup">
    <div
      class="position-relative row form-group prop-elems"
      [ngClass]="{
        'filter-row': property.uiType === 'lookupfilter',
        'flex-wrap': property.uiType === 'querymap',
        'pagevar-div': property.lookupTo === 'parameterMapStdGridPageVar' || property.lookupTo === 'queryMapPageVar'
      }"
      *ngIf="
        !property?.hide &&
        property?.hide !== 'yes' &&
        property.uiType !== 'urlgroup' &&
        property.uiType !== 'runtimeConfig' &&
        property.uiType !== 'importconfig' &&
        property.uiType !== 'exportconfig' &&
        property.uiType !== 'indextbl' &&
        property.uiType !== 'foreignkeytbl' &&
        property.uiType !== 'tableacl' &&
        property.uiType !== 'searchablefields' &&
        property.uiType !== 'lookupconfig' &&
        property.uiType !== 'pagelookupconfig' &&
        property.uiType !== 'cudconfig' &&
        property.uiType !== 'queryViewParamMapping' &&
        property.uiType !== 'pageVariablesProperty' &&
        property.uiType !== 'navigationStyleSelector' &&
        conditionalCheck[property.name] &&
        !additionalCondCheck[property.name] &&
        !(isFromModernize && currentScreen?.pageType === 'detail' &&
          (property.lookupTo === 'parameterMapStdGrid' || property.lookupTo === 'parameterMapStdGridPageVar')) &&
        (currentPage?.currentPage !== 'templates' ||
          (currentPage?.currentPage === 'templates' && property.uiType !== 'font') ||
          (currentPage?.currentPage === 'templates' &&
            property.uiType === 'font' &&
            isPropertyNotFontGroup(property.name)))
      "
    >
      <label
        [attr.for]="property.name"
        [ngClass]="
          actorsData
            ? 'col-sm-5 col-form-label'
            : property.uiType === 'querymap'
              ? property.lookupTo === 'parameterMapHoldValParams' ||
                property.lookupTo === 'parameterMapStdGrid' ||
                property.lookupTo === 'parameterMapStdGridPageVar' ||
                property.lookupTo === 'queryMapPageVar' ||
                property.lookupTo === 'navigatePageParams'
                ? 'col-sm-8 col-form-label param-map-label'
                : 'col-sm-6 col-form-label'
              : 'col-sm-6 col-form-label'
        "
      >
        <span>{{ getPropertyTitle(property.title) | translate }}</span>
        <!-- Icons container to prevent overlapping -->

          <!-- Info icon - always shows first when infoBubble exists -->
          <i
            class="fa fa-info-circle field-info"
            [ngClass]="{
              'field-info-with-error':
                ((property.name === 't_list_query' || property.name === 't_detail_query') && getQvValidation('queryValidation')) ||
                (property.name === 't_mandatory_filters' && getQvValidation('paramValidation')),
              'field-info-neutral': isBetaAccessPrivilegeConsumable
            }"
            showDelay="100"
            hideDelay="100"
            tooltipPosition="bottom"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            [pTooltip]="property.infoBubble | translate"
            *ngIf="
              property.infoBubble &&
              property.infoBubble !== '' &&
              ((val.name !== 'Language Code' && property.name === 'f_dVal' && !val.sysgen) || property.name !== 'f_dVal')
            "></i>
          <!-- Error icon -->
          <i
            class="qv-error-info-icon pi pi-exclamation-circle"
            showDelay="100"
            hideDelay="100"
            tooltipPosition="bottom"
            tooltipStyleClass="label-tooltip custom-tooltip-properties qv-error-info-icon"
            [pTooltip]="
              ((property.name === 't_list_query' || property.name === 't_detail_query') &&
              getQvValidation('queryValidation'))
                ? getQvValidation('queryValidation')
                : (property.name === 't_mandatory_filters' && getQvValidation('paramValidation'))
                  ? getQvValidation('paramValidation')
                  : 'Error information'
            "
            *ngIf="
              property.infoBubble &&
              property.infoBubble !== '' &&
              ((val.name !== 'Language Code' && property.name === 'f_dVal' && !val.sysgen) || property.name !== 'f_dVal') &&
              (((property.name === 't_list_query' || property.name === 't_detail_query') && getQvValidation('queryValidation')) ||
              (property.name === 't_mandatory_filters' && getQvValidation('paramValidation')))
            "

          ></i>

        <i
          class="fa fa-info-circle field-info"
          [ngClass]="{ 'field-info-neutral': isBetaAccessPrivilegeConsumable }"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ lCodeInfo }}"
          *ngIf="val.name === 'Language Code' && property.name === 'f_dVal'"
        ></i>
        <!-- RR2023-2349 FIX -->
      </label>
      <div
        [ngClass]="{
          'col-sm-7 p-0 input-ctrl': actorsData,
          'col-sm-6 p-0 input-ctrl': !actorsData && property.uiType !== 'querymap',
          'col-sm-12 pr-0 input-ctrl': property.uiType === 'querymap',
          'd-flex justify-content-end': currentPage?.currentPage === 'templates'
        }"
        [formGroup]="formGroup"
        #fg="ngForm"
      >
        <ng-container [ngSwitch]="property.uiType">
          <ng-template [ngSwitchCase]="'checkbox'">
            <span>
              <ng-container *ngIf="isBetaAccessPrivilegeConsumable; else standardCheckboxControl">
                <p-toggleswitch
                  [inputId]="property.name"
                  [name]="property.name"
                  [disabled]="disallowEdit || disallowForReference"
                  [attr.id]="property.name"
                  [formControlName]="property.name"
                  (onChange)="onCheckboxChange($event, property)"
                ></p-toggleswitch>
              </ng-container>
              <ng-template #standardCheckboxControl>
                <p-checkbox
                  [binary]="true"
                  [inputId]="property.name"
                  [name]="property.name"
                  [disabled]="disallowEdit || disallowForReference"
                  [attr.id]="property.name"
                  [formControlName]="property.name"
                  (onChange)="onCheckboxChange($event, property)"
                ></p-checkbox>
              </ng-template>
            </span>
          </ng-template>
          <ng-template [ngSwitchCase]="'boolean'">
            <ng-container *ngIf="isBetaAccessPrivilegeConsumable; else standardBooleanCheckboxControl">
              <p-toggleswitch
                [inputId]="property.name"
                [disabled]="disallowEdit || disallowForReference"
                [name]="property.name"
                [attr.id]="property.name"
                [formControlName]="property.name"
                (onChange)="onCheckboxChange($event, property)"
              ></p-toggleswitch>
            </ng-container>
            <ng-template #standardBooleanCheckboxControl>
              <p-checkbox
                [binary]="true"
                [inputId]="property.name"
                [disabled]="disallowEdit || disallowForReference"
                [name]="property.name"
                [attr.id]="property.name"
                [formControlName]="property.name"
                (onChange)="onCheckboxChange($event, property)"
              ></p-checkbox>
            </ng-template>
          </ng-template>
          <ng-template [ngSwitchCase]="'dynamicBoolean'">
            <ng-container *ngIf="isBetaAccessPrivilegeConsumable; else standardDynamicBooleanCheckboxControl">
              <p-toggleswitch
                [inputId]="property.name"
                [name]="property.name"
                [attr.id]="property.name"
                [formControlName]="property.name"
                (onChange)="onCheckboxChange($event, property)"
              ></p-toggleswitch>
            </ng-container>
            <ng-template #standardDynamicBooleanCheckboxControl>
              <p-checkbox
                [binary]="true"
                [inputId]="property.name"
                [name]="property.name"
                [attr.id]="property.name"
                [formControlName]="property.name"
                (onChange)="onCheckboxChange($event, property)"
              ></p-checkbox>
            </ng-template>
          </ng-template>
          <ng-template [ngSwitchCase]="'input'">
            <vb-input-text
              [element]="property"
              [formControlName]="property.name"
              [currentSelectedTreeNode]="currentSelectedTreeNode"
              [currentPage]="currentPage"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-input-text>
          </ng-template>
          <ng-template [ngSwitchCase]="'integer'">
            <vb-input-number
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-input-number>
          </ng-template>
          <ng-template [ngSwitchCase]="'minMaxInteger'">
            <p-inputNumber
              class="form-control form-control-sm"
              [formControlName]="property.name"
              [min]="property.minValue"
              [max]="property.maxValue"
            ></p-inputNumber>
          </ng-template>
          <ng-template [ngSwitchCase]="'decimal'">
            <vb-dec-number
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-dec-number>
          </ng-template>
          <ng-template [ngSwitchCase]="'textarea'">
            <vb-textarea
              [element]="property"
              [currentSelectedTreeNode]="currentSelectedTreeNode"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-textarea>
          </ng-template>
          <ng-template [ngSwitchCase]="'string'">
            <vb-input-text
              [element]="property"
              [currentSelectedTreeNode]="currentSelectedTreeNode"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
              *ngIf="this.currentPage?.currentPage === 'screens'"
            >
            </vb-input-text>
            <vb-input-text
              [element]="property"
              [currentSelectedTreeNode]="currentSelectedTreeNode"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
              [isAlphaNumWithSpace]="true"
              *ngIf="this.currentPage?.currentPage !== 'screens'"
            >
            </vb-input-text>
          </ng-template>
		      <ng-template [ngSwitchCase]="'editableString'">
            @if (property.name === 'dataKey') {
              <vb-data-key-editor
                [formControlName]="property.name"
                [currentScreen]="currentScreen"
                [formData]="formData"
              ></vb-data-key-editor>
            } @else {
              <input
                type="text"
                class="form-control form-control-sm"
                [formControlName]="property.name"
                pTooltip="{{ property.infoBubble | translate }}"
                tooltipPosition="top"
              />
              @if (isEditable) {
                <i class="fa fa-pencil editable-string-icon" pTooltip="Edit"
                  tooltipPosition="top"
                ></i>
              }
            }
		      </ng-template>
          <ng-template [ngSwitchCase]="'url'">
            <vb-input-text
              [element]="property"
              [currentSelectedTreeNode]="currentSelectedTreeNode"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-input-text>
          </ng-template>
          <ng-template [ngSwitchCase]="'uripath'">
            <vb-input-text
              [element]="property"
              [currentSelectedTreeNode]="currentSelectedTreeNode"
              [currentPage]="currentPage"
              [formControlName]="property.name"
              [disableField]="disallowEdit"
              [formData]="formData"
            >
            </vb-input-text>
          </ng-template>
          <ng-template [ngSwitchCase]="'dropdown'">
            <p-select
              [showClear]="
                !(formData[property.name] && formDefaultValues[property.name] === formData[property.name]) ||
                (formData[property.name] && !formDefaultValues[property.name] && pageName === 'consumedrest')
              "
              [options]="getPossibleValues(property)"
              (onClear)="clearVal($event, property)"
              optionLabel="name"
              optionValue="value"
              appendTo="body"
              [formControlName]="property.name"
              class="form-control form-control-sm"
              placeholder="Select"
            >
              <ng-template let-possibleValue pTemplate="item">
                <div class="value-item" [ngClass]="possibleValue.value">
                  <div>{{ possibleValue.name }}</div>
                </div>
              </ng-template>
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'tabletypedropdown'">
            <vb-tbl-type-dropdown
              [options]="property.possibleValues"
              [element]="property"
              [formData]="formData"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [showRdbmsProps]="showRdbmsProps"
            >
            </vb-tbl-type-dropdown>
          </ng-template>
          <ng-template [ngSwitchCase]="'btnaction'">
            <vb-btn-action
              [formControlName]="property.name"
              [element]="property"
              [currentScreen]="currentScreen"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
              [currentTable]="currentTable"
              [isFromModernize]="isFromModernize"
            >
            </vb-btn-action>
          </ng-template>
          <ng-template [ngSwitchCase]="'btnbeforeaction'">
            <vb-btn-before-action
              class="w-100"
              [formControlName]="property.name"
              [element]="property"
              [currentScreen]="currentScreen"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
              [isFromModernize]="isFromModernize"
            >
            </vb-btn-before-action>
          </ng-template>
          <ng-template [ngSwitchCase]="'dynamicdropdown'">
            <vb-dynamic-dropdown
              [options]="property?.possibleValuesFrom | filteroptions: formGroup : formData"
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
            >
            </vb-dynamic-dropdown>
          </ng-template>
          <ng-template [ngSwitchCase]="'staticdropdown'">
            <p-select
              *ngIf="property.name !== 'dateTimeFormat'"
              [showClear]="true"
              (onClear)="clearVal($event, property)"
              [options]="property?.possibleValuesFrom | staticoptions"
              placeholder="Select"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControlName]="property.name"
              class="form-control form-control-sm"
              placeholder="Select"
            >
            </p-select>
            <p-select
              *ngIf="property.name === 'dateTimeFormat'"
              [showClear]="true"
              (onClear)="clearVal($event, property)"
              [options]="property?.possibleValuesFrom | staticoptions: drpSearchTxt"
              placeholder="Select"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [formControlName]="property.name"
              [filter]="true"
              filterBy="label"
              (onFilter)="searchdrp($event, property.name)"
              class="form-control form-control-sm"
              placeholder="Select"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'dynamiccontrol'">
            <vb-default-val-comp
              [formData]="formData"
              [formGroup]="formGroup"
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
            >
            </vb-default-val-comp>
          </ng-template>
          <ng-template [ngSwitchCase]="'filteroptions'">
            <vb-filter-options
              class="w-100"
              [formData]="formData"
              [formGroup]="formGroup"
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [currentScreen]="currentScreen"
            >
            </vb-filter-options>
          </ng-template>
          <ng-template [ngSwitchCase]="'restconsumedauthenticationtypedropdown'">
            <vb-rest-consumed-authentication-type-dropdown
              [formData]="formData"
              [formGroup]="formGroup"
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              class="rest-consument-authentication-option-width"
            >
            </vb-rest-consumed-authentication-type-dropdown>
          </ng-template>
          <!-- Transient field Mapping to foreign key parent table -->
          <ng-template [ngSwitchCase]="'transientmapping'">
            <vb-transient-field-mapping
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
              [formFields]="formGroup"
            >
            </vb-transient-field-mapping>
          </ng-template>
          <ng-template [ngSwitchCase]="'querybuilder'">
            <vb-vs-qb-builder
              [element]="property"
              [CurrentPicklist]="currentPicklist"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name) || property?.disable?.toLowerCase() === 'true'"
              [currentScreen]="currentScreen"
              [formData]="formData"
              [currentNode]="currentNode"
              [pickList]="current"
              [techStack]="techStackData"
            >
            </vb-vs-qb-builder>
          </ng-template>
          <ng-template [ngSwitchCase]="'formulaeditor'">
            <vb-formula-builder
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [currentNode]="currentClickedField"
              [fieldIdMap]="fieldIdMap"
              [dataModelOrders]="dataModelOrders"
              (errorStatus)="onStatusChange($event)"
              [ngClass]="{'error-border':formulaBuilderErrorStatus==='error','warning-border':formulaBuilderErrorStatus==='warning'}"
            ></vb-formula-builder>
          </ng-template>
          <ng-template [ngSwitchCase]="'colorpicker'">
            <vb-colorpicker
              [element]="property"
              [formControlName]="property.name"
              (changedColor)="setColorChange($event)"
              [currentPage]="currentPage"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [ngClass]="{ 'w-100': currentPage?.currentPage === 'templates' }"
            ></vb-colorpicker>
          </ng-template>
          <ng-template [ngSwitchCase]="'lookup'">
            <div class="auto-comp-wrap" *ngIf="property.name !== 'f_lookupTo' || applicationType === 'INDEPENDENT'">
              <div class="custom-icon-wrapper" [ngClass]="{'error-border':property.name==='t_pTable' && parentTblErrorMsg}">
                <p-autocomplete
                [formControlName]="property.name"
                [suggestions]="results"
                appendTo="body"
                (completeMethod)="search($event, property)"
                [dropdown]="true"
                [forceSelection]="true"
                field="name"
                [disabled]="disallowForReference"
                [attr.multiple]="property.multiple ? '' : null"
                [group]="property.lookupTo === 'listofavailablepages' && isMicroserviceSuite && !isCustomActionButton()"
                panelStyleClass="custom-autocom-panel"
              >
                <ng-template
                  let-group
                  pTemplate="group"
                  *ngIf="property.lookupTo === 'listofavailablepages' && isMicroserviceSuite && !isCustomActionButton()"
                >
                  <div class="field-item group-header">
                    <i class="pi pi-folder" style="margin-right: 0.5rem"></i>
                    <span style="font-weight: 600">{{ group.label }}</span>
                    <span style="margin-left: 0.5rem; opacity: 0.7">({{ group.items?.length }})</span>
                  </div>
                </ng-template>
                <ng-template let-field #item>
                  <div class="field-item text-overflow" [class.bor-top]="field?.separator">
                    <span>{{ field.name }}</span>
                  </div>
                </ng-template>
              </p-autocomplete>
               <i class="fa fa-exclamation-circle error-icon-1" *ngIf="property.name==='t_pTable' && parentTblErrorMsg" (mouseenter)="showParentTableErrorMsg()" (mouseleave)="showParentTableErrorMsg()"></i>
              </div>
              <em
                class="p-select-clear-icon p-autoComplete-clear-icon pi pi-times"
                [ngClass]="{ 'disabled-em': formGroup?.get(property.name).status === 'DISABLED' }"
                *ngIf="formGroup?.get(property.name).value"
                (click)="removeConfirmationDetailPage(property.name)"
                (keyup.enter)="removeConfirmationDetailPage(property.name)"
                tabindex="1"
                aria-label="Clear autocomplete"
              >
              </em>

               <div class="warning-wrapper" >
                <div class="text-danger val-err" *ngIf="property.name==='t_pTable' && parentTblErrorMsgPopupVisible">
                  <div class="warning-header">
                    <p>Error</p>
                    <i class="pi pi-times"></i>
                  </div>
                  {{ parentTblErrorMsg }}
                </div>
              </div>
            </div>
            <div class="auto-comp-wrap" *ngIf="property.name === 'f_lookupTo' && applicationType !== 'INDEPENDENT'">
              <p-select
                [options]="groupedLookUpTables"
                optionLabel="name"
                optionValue="sid"
                [showClear]="formData[property.name]"
                (onClear)="clearVal($event, property)"
                (click)="preventCollapse()"
                panelStyleClass="custom-panel"
                formControlName="f_lookupTo"
                [group]="true"
              >
                <!-- <ng-template pTemplate="selectedItem">
                  <span> {{formGroup.get('f_lookupTo').value}}</span>
              </ng-template> -->
                <ng-template let-option pTemplate="group">
                  <div
                    class="group-header"
                    [ngClass]="{ collapsed: !option.expanded }"
                    (click)="toggleGroup(option)"
                    (keyup.enter)="toggleGroup(option)"
                    tabindex="2"
                    aria-label="Toggle group"
                  >
                    <i class="pi pi-chevron-down" [ngClass]="{ 'pi-chevron-up': option.expanded }"></i>
                    <span>{{ option.label }}</span>
                  </div>
                  <!-- <div class="sub-group" [ngClass]="{'expanded': option.expanded}" >
                  <ul *ngIf="option.expanded">
                    <li *ngFor="let item of option.items"(click)="triggerLookUpListener(item)" >
                      <span >{{item.name}}</span>
                    </li>
                  </ul>
                  </div> -->
                </ng-template>
                <ng-template let-field pTemplate="item">
                  <div
                    class="field-item sub-group"
                    [ngClass]="{ expanded: !field.expanded }"
                    [class.ind-item]="field.ind"
                  >
                    <div>{{ field.name }}</div>
                  </div>
                  <!-- <div class="sub-group" [ngClass]="{'expanded': option.expanded}" >
                    <ul *ngIf="option.expanded">
                      <li  >
                        <span >{{field.name}}</span>
                      </li>
                    </ul>
                  </div> -->
                </ng-template>
              </p-select>
            </div>
          </ng-template>

          <ng-template [ngSwitchCase]="'customlookup'">
            <div class="auto-comp-wrap" *ngIf="property.name !== 'f_lookupTo' || applicationType === 'INDEPENDENT'">
              <p-autocomplete
                [formControlName]="property.name"
                [suggestions]="results"
                appendTo="body"
                (completeMethod)="search($event, property)"
                [dropdown]="true"
                [forceSelection]="true"
                field="name"
                [disabled]="disallowForReference"
                [attr.multiple]="property.multiple ? '' : null"
                panelStyleClass="custom-autocom-panel"
                (onSelect)="onSelectSearableFields($event, property)"
                [group]="true"
              >
                <ng-template let-group #group>
                  <span>{{ group.name }}</span>
                </ng-template>
                <ng-template let-field #item>
                  <div
                    class="field-item text-overflow"
                    [ngClass]="{
                      'item-disabled':
                        !field?.searchable &&
                        techStackData?.textSearch === 'Elastic Search' &&
                        currentScreen?.pageTableType !== 'QUERY_VIEW'
                    }"
                    [class.bor-top]="field?.separator"
                  >
                    <span>{{ field.name }}</span>
                    <span class="search-label font-italic">
                      {{ populateOptionSuffix(field) }}
                    </span>
                  </div>
                </ng-template>
              </p-autocomplete>
              <em
                class="p-select-clear-icon p-autoComplete-clear-icon pi pi-times"
                [ngClass]="{ 'disabled-em': formGroup?.get(property.name).status === 'DISABLED' }"
                *ngIf="formGroup?.get(property.name).value"
                (click)="clearAutoCompleteData(property.name)"
                (keyup.enter)="clearAutoCompleteData(property.name)"
                tabindex="3"
                aria-label="Clear autocomplete"
              >
              </em>
            </div>
            <div class="auto-comp-wrap" *ngIf="property.name === 'f_lookupTo' && applicationType !== 'INDEPENDENT'">
              <p-select
                [options]="groupedLookUpTables"
                optionLabel="name"
                optionValue="sid"
                [showClear]="formData[property.name]"
                (onClear)="clearVal($event, property)"
                (click)="preventCollapse()"
                panelStyleClass="custom-panel"
                formControlName="f_lookupTo"
                [group]="true"
              >
                <!-- <ng-template pTemplate="selectedItem">
                  <span> {{formGroup.get('f_lookupTo').value}}</span>
              </ng-template> -->
                <ng-template let-option pTemplate="group">
                  <div
                    class="group-header"
                    [ngClass]="{ collapsed: !option.expanded }"
                    (click)="toggleGroup(option)"
                    (keyup.enter)="toggleGroup(option)"
                    tabindex="4"
                    aria-label="Toggle group"
                  >
                    <i class="pi pi-chevron-down" [ngClass]="{ 'pi-chevron-up': option.expanded }"></i>
                    <span>{{ option.label }}</span>
                  </div>
                  <!-- <div class="sub-group" [ngClass]="{'expanded': option.expanded}" >
                  <ul *ngIf="option.expanded">
                    <li *ngFor="let item of option.items"(click)="triggerLookUpListener(item)" >
                      <span >{{item.name}}</span>
                    </li>
                  </ul>
                  </div> -->
                </ng-template>
                <ng-template let-field pTemplate="item">
                  <div
                    class="field-item sub-group"
                    [ngClass]="{ expanded: !field.expanded }"
                    [class.ind-item]="field.ind"
                  >
                    <div class="field-item text-overflow" [class.bor-top]="field?.separator">
                      <span
                        [ngClass]="{
                          'item-disabled': !field.searchable && techStackData.textSearch === 'Elastic Search'
                        }"
                        >{{ field.name }}</span
                      >
                      <span class="search-label font-italic">
                        {{ populateOptionSuffix(field) }}
                      </span>
                    </div>
                  </div>
                  <!-- <div class="sub-group" [ngClass]="{'expanded': option.expanded}" >
                    <ul *ngIf="option.expanded">
                      <li  >
                        <span >{{field.name}}</span>
                      </li>
                    </ul>
                  </div> -->
                </ng-template>
              </p-select>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'groupedlookup'">
            <div class="auto-comp-wrap">
              <p-autocomplete
                [formControlName]="property.name"
                [suggestions]="results"
                [group]="true"
                (onShow)="attachInfiniteScroll(property.name)"
                (completeMethod)="search($event, property)"
                [disabled]="disallowForReference"
                [dropdown]="true"
                [forceSelection]="true"
                field="name"
                appendTo="body"
                [attr.multiple]="property.multiple ? '' : null"
              >
              </p-autocomplete>

              <em
                class="p-select-clear-icon p-autoComplete-clear-icon pi pi-times group-clear"
                *ngIf="formGroup?.get(property.name).value"
                (click)="clearAutoCompleteData(property.name)"
                (keyup.enter)="clearAutoCompleteData(property.name)"
                tabindex="5"
                aria-label="Clear autocomplete"
              >
              </em>
            </div>
          </ng-template>

          <ng-template [ngSwitchCase]="'editabledropdown'">
            <p-select
              [showClear]="true"
              (onClear)="clearVal($event, property)"
              [options]="property.possibleValues"
              [formControlName]="property.name"
              [editable]="true"
              optionLabel="name"
              optionValue="value"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'iconimageselector'">
            <vb-icon-selector
              [element]="property"
              [formControlName]="property.name"
              type="iconimage"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [iconSize]="iconSize"
            >
            </vb-icon-selector>
          </ng-template>
          <ng-template [ngSwitchCase]="'iconselector'">
            <vb-icon-selector
              [element]="property"
              [formControlName]="property.name"
              type="icon"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [iconSize]="iconSize"
              [curNode]="selectedNodeType"
            ></vb-icon-selector>
            <div class="loader-container" *ngIf="imageLoading">
              <p-progress-spinner></p-progress-spinner>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'imageselector'">
            <button
              type="button"
              class="btn btn-primary btn-sm img-btn"
              [disabled]="disallowEdit"
              (click)="imageSelector.click()"
            >
              <i class="fa fa-plus"></i>
            </button>
            <input
              type="file"
              (change)="onIconUpload($event, property.name, property)"
              class="invisible"
              #imageSelector
            />
            <div class="loader-container" *ngIf="imageLoading">
              <p-progress-spinner></p-progress-spinner>
            </div>
            <img
              [attr.id]="property.name + '_img'"
              class="prop-img-uploader"
              [ngClass]="{ imgAbsent: !imagePresent }"
              [alt]="property.name"
              #imageElement
            />
            <div class="d-flex align-items-center" *ngIf="imagePresent">
              <span
                class="clear cursor-pointer"
                (click)="clearIconValue(property)"
                (keyup.enter)="zoomIn()"
                tabindex="0"
                aria-label="Zoom In"
                ><i class="pi pi-times"></i
              ></span>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'pwaimageselector'">
            <button
              type="button"
              class="btn btn-primary btn-sm img-btn"
              [disabled]="disallowEdit"
              (click)="pwaSelector.click()"
            >
              <i class="fa fa-plus"></i>
            </button>
            <input
              type="file"
              (change)="onPWAIconUpload($event, property.name, property)"
              class="invisible"
              accept=".svg, .png"
              #pwaSelector
            />
            <div class="loader-container" *ngIf="imageLoading">
              <p-progress-spinner></p-progress-spinner>
            </div>
            <img
              [attr.id]="property.name + '_img'"
              class="prop-img-uploader"
              [alt]="property.name"
              #pwaElement
              [ngClass]="{ imgAbsent: !pwaImagePresent }"
            />
            <div class="d-flex align-items-center" *ngIf="pwaImagePresent">
              <span
                class="clear cursor-pointer"
                (click)="clearPWAIconValue(property)"
                (keyup.enter)="clearPWAIconValue(property)"
                tabindex="7"
                aria-label="Clear pwa"
                ><i class="pi pi-times"></i
              ></span>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'rolelookup'">
            <vb-role-lookup
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
            ></vb-role-lookup>
          </ng-template>
          <ng-template [ngSwitchCase]="'pickuplist'">
            <vb-pickup-list
              [fieldIdMap]="fieldIdMap"
              [element]="property"
              [formData]="formData"
              [pickList]="pickList"
              [disableField]="disallowEdit || disallowForReference"
              [formControlName]="property.name"
              [currNodeType]="currNodeType"
              [currentScreen]="currentScreen"
              [techStackData]="techStackData"
            >
            </vb-pickup-list>
          </ng-template>
          <ng-template [ngSwitchCase]="'font'">
            <vb-font
              [formControlName]="property.name"
              [element]="property"
              [currentPage]="currentPage"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [ngClass]="{ 'w-100': currentPage?.currentPage === 'templates' }"
              [formData]="formData"
              #fontComponentRef
            ></vb-font>
          </ng-template>
          <ng-template [ngSwitchCase]="'chips'">
            <p-chips [formControlName]="property.name" [disabled]="disallowEdit"> </p-chips>
          </ng-template>
          <ng-template [ngSwitchCase]="'checkboxgroup'">
            <vb-checkbox-group [formControlName]="property.name">
              <vb-checkbox *ngFor="let option of property.possibleValues" [value]="option.value" [option]="option.name">
              </vb-checkbox>
            </vb-checkbox-group>
          </ng-template>
          <ng-template [ngSwitchCase]="'conditionalformatter'">
            <vb-conditional-formatter
              [formControlName]="property.name"
              [element]="property"
              [node]="currentNode"
              [formData]="formData"
              [fieldName]="getFieldName()"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [showFormattingButton]="property.name !== 'styleClass'"
            >
            </vb-conditional-formatter>
          </ng-template>
          <ng-template [ngSwitchCase]="'plaintexteditor'">
            <vb-editor-with-autocomplete
              class="editor-comp"
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-editor-with-autocomplete>
          </ng-template>
          <ng-template [ngSwitchCase]="'jsoneditor'">
            <vb-json-editor
              [element]="property"
              [formControlName]="property.name"
              [config]="{ language: 'json' }"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-json-editor>
          </ng-template>
          <ng-template [ngSwitchCase]="'jsonEditor'">
            <vb-json-editor
              [element]="property"
              [formControlName]="property.name"
              [config]="{ language: 'json' }"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-json-editor>
          </ng-template>
          <ng-template [ngSwitchCase]="'jsoneditorwithschema'">
            <vb-json-editor
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [config]="{ language: 'json', schema: true }"
              [formData]="formData"
            >
            </vb-json-editor>
          </ng-template>
          <ng-template [ngSwitchCase]="'xmleditor'">
            <vb-json-editor
              [element]="property"
              [formControlName]="property.name"
              [config]="{ language: 'xml' }"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formData]="formData"
            >
            </vb-json-editor>
          </ng-template>
          <ng-template [ngSwitchCase]="'xmleditorwithschema'">
            <vb-json-editor
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [config]="{ language: 'xml', schema: true }"
              [formData]="formData"
            >
            </vb-json-editor>
          </ng-template>
          <ng-template [ngSwitchCase]="'fontselector'">
            <vb-font-selector
              [element]="property"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [currNodeType]="currNodeType"
            >
            </vb-font-selector>
          </ng-template>
          <ng-template [ngSwitchCase]="'date'">
            <p-datepicker
              appendTo="body"
              [formControlName]="property.name"
              dateFormat="mm-dd-yy"
              [showIcon]="true"
            ></p-datepicker>
          </ng-template>
          <ng-template [ngSwitchCase]="'size'">
            <vb-size
              [formControlName]="property.name"
              [element]="property"
              [currentPage]="currentPage"
              [currNodeType]="currNodeType"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
            ></vb-size>
          </ng-template>
          <ng-template [ngSwitchCase]="'querytype'">
            <vb-query-type
              [formControlName]="property.name"
              [formData]="formData"
              [element]="property"
              [currentPage]="currentPage"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
            ></vb-query-type>
          </ng-template>
          <ng-template [ngSwitchCase]="'radiobutton'">
            <div
              class="radio-wrapper"
              [ngClass]="{ 'column-layout': property.name === 'displayFilterIn' }"
              [pTooltip]="getAllowEditingTooltip(property)"
              [tooltipDisabled]="!shouldShowAllowEditingTooltip(property)"
              tooltipPosition="top"
              [showDelay]="100"
            >
              @if (isBetaAccessPrivilegeConsumable) {
                <p-selectbutton
                  [options]="betaRadioOptionsMap[property.name] || []"
                  optionLabel="label"
                  optionValue="value"
                  optionDisabled="disabled"
                  [formControlName]="property.name"
                  [allowEmpty]="false"
                  [disabled]="disallowEdit || disallowForReference"
                ></p-selectbutton>
              } @else {
                <div *ngFor="let option of property.possibleValues" class="field-radiobutton"
                  [class.radio-option-disabled]="isRadioOptionDisabled(property.name, option.value)">
                  <p-radiobutton
                    [name]="property.name"
                    [formControlName]="property.name"
                    [value]="option.value"
                    [disabled]="disallowEdit || disallowForReference"
                    [inputId]="property.name + option.value"
                  >
                  </p-radiobutton>
                  <label class="mb-0 ml-1 mr-2" [for]="property.name + option.value"
                    >{{ getPropertyValue(option.name, property.name) }}
                  </label>
                </div>
              }
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'style'">
            <vb-style-editor [element]="property" [formControlName]="property.name" [disableField]="disallowEdit || isModernizeDisabled(property.name)">
            </vb-style-editor>
          </ng-template>
          <ng-template [ngSwitchCase]="'gridster'">
            <vb-mobile-layout
              [element]="property"
              [formControlName]="property.name"
              [currentScreen]="currentScreen"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
            >
            </vb-mobile-layout>
          </ng-template>
          <ng-template [ngSwitchCase]="'mail'">
            <vb-mail-template
              [element]="formData"
              [actorsData]="actorsData"
              [formControlName]="property.name"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [curNode]="curNode"
              [fields]="fields"
            >
            </vb-mail-template>
          </ng-template>
          <ng-template [ngSwitchCase]="'tilepicker'">
            <vb-tilepicker [disableField]="disallowEdit || isModernizeDisabled(property.name)" [element]="property" [formControlName]="property.name">
            </vb-tilepicker>
          </ng-template>
          <ng-template [ngSwitchCase]="'multiselect'">
            <p-multiselect
              [options]="
                property.possibleValues
                  | dynamicoptions
                    : property?.possibleValuesFrom
                    : (property.name === 'hideFieldIds'
                        ? (dynamicPossibleOptionsForHide$ | async)
                        : (dynamicPossibleOptions$ | async))
                    : formData?.sid
              "
              [formControlName]="property.name"
              appendTo="body"
              optionLabel="name"
              optionValue="value"
              [maxSelectedLabels]="3"
              selectedItemsLabel="{0} items selected"
              class="multiselect-style"
              [showClear]="true"
            >
              <ng-template let-possibleValue pTemplate="item">
                <div class="options-item">
                  <div>{{ possibleValue.name }}</div>
                </div>
              </ng-template>
            </p-multiselect>
          </ng-template>
          <ng-template [ngSwitchCase]="'consumerapps'">
            <p-select
              class="w-100 consumers"
              [options]="msApps"
              [formControlName]="property.name"
              optionLabel="name"
              dataKey="sid"
              placeholder="Select a Consumer"
              [filter]="true"
              filterBy="name"
              appendTo="body"
              scrollHeight="240px"
              panelStyleClass="custom-panel"
              [showClear]="true"
            ></p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'dropdownwithindexdesigner'">
            <vb-dropdown-with-indexdesigner
              [formData]="formData"
              [tableIdMap]="tableIdMap"
              [fieldIdMap]="fieldIdMap"
              [pickList]="pickList"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [formFields]="formGroup"
              [dataModelOrders]="dataModelOrders"
              [formControlName]="property.name"
              [element]="property"
              [currentNode]="currentClickedField"
            ></vb-dropdown-with-indexdesigner>
          </ng-template>
          <ng-template [ngSwitchCase]="'searchablecontrol'">
            <vb-searchable-ctrl
              [formData]="formData"
              [disableField]="disallowEdit || disallowForReference"
              [techStackData]="techStackData"
              [formControlName]="property.name"
              [property]="property"
              [currentNode]="currentClickedField"
            ></vb-searchable-ctrl>
          </ng-template>
          <ng-template [ngSwitchCase]="'querymap'">
            <vb-query-mapping
              [element]="property"
              [formData]="formData"
              [formControlName]="property.name"
              [currNodeType]="currNodeType"
              [currentScreen]="currentScreen"
              [currentNode]="currentNode"
              [disableField]="disallowEdit || isModernizeDisabled(property.name)"
              [isFromModernize]="isFromModernize"
              [allScreens]="allScreens"
              [techStackData]="techStackData"
            >
            </vb-query-mapping>
          </ng-template>
        </ng-container>

        <span
          class="d-flex flex-column justify-content-center"
          *ngIf="currentPage?.currentPage === 'templates' && !disallowEdit"
        >
          <p-splitbutton
            appendTo="body"
            (onDropdownClick)="getMenuOptions(property, propertyGroup)"
            class="property-pane-action-icon d-flex flex-column justify-content-center"
            [model]="menuItems"
          >
          </p-splitbutton>
        </span>
      </div>
    </div>
    <div *ngIf="property.uiType === 'urlgroup' && !additionalCondCheck[property.name]" [formGroup]="formGroup" #fg="ngForm">
      <!-- Environment URL Dialog Trigger Button -->
      <div class="position-relative row form-group prop-elems">
        <span class="col-sm-6 col-form-label">
          {{ property.title | translate }}
          <i
            class="fa fa-info-circle field-info"
            [ngClass]="{ 'field-info-neutral': isBetaAccessPrivilegeConsumable }"
            showDelay="100"
            hideDelay="100"
            tooltipPosition="bottom"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ property.infoBubble | translate }}"
            *ngIf="property.infoBubble"
          ></i>
        </span>
        <div class="col-sm-6 p-0">
          <button
            pButton
            type="button"
            class="p-button-outlined p-button-sm env-url-dialog-btn"
            (click)="openProviderEnvUrlConfig()"
            [disabled]="disallowEdit"
            [pTooltip]="
              getFilteredEnvCount() && getConfiguredEnvCount() < getFilteredEnvCount()
                ? ('ENV_URLS_NOT_CONFIGURED' | translate)
                : null
            "
            tooltipPosition="top"
          >
            <i class="pi pi-link"></i>
            <span class="env-url-btn-text">
              {{ 'CONFIGURE' | translate }}
              <span class="env-count-badge" *ngIf="getFilteredEnvCount()"
                >({{ getConfiguredEnvCount() }}/{{ getFilteredEnvCount() }})</span
              >
            </span>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="property.uiType === 'foreignkeytbl' && conditionalCheck[property.name]" [formGroup]="formGroup">
      <vb-vs-foreign-key-tbl
        [fieldIdMap]="fieldIdMap"
        [tableIdMap]="tableIdMap"
        [element]="property"
        [pickList]="pickList"
        [formData]="formData"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [applicationType]="applicationType"
      ></vb-vs-foreign-key-tbl>
    </div>
    <div *ngIf="property.uiType === 'indextbl' && conditionalCheck[property.name]" [formGroup]="formGroup">
      <vb-index-designer
        [formData]="formData"
        [tableIdMap]="tableIdMap"
        [fieldIdMap]="fieldIdMap"
        [pickList]="pickList"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [formFields]="formGroup"
      ></vb-index-designer>
    </div>
    <div *ngIf="property.uiType === 'navigationStyleSelector' && conditionalCheck[property.name]" [formGroup]="formGroup" class="navigation-style-section">
      <label class="section-label" [attr.for]="property.name">{{ getPropertyTitle(property.title) | translate }}</label>
      <span class="section-subtitle">{{ 'NAV_STYLE_SUBTITLE' | translate }}</span>
      <vb-navigation-style-selector
        [options]="property.possibleValues"
        [formControlName]="property.name"
        [disabled]="disallowEdit"
        [attr.id]="property.name"
      ></vb-navigation-style-selector>
    </div>
    <div
      class="lookup-def-section"
      *ngIf="property.uiType === 'lookupconfig' && conditionalCheck[property.name]"
      [formGroup]="formGroup"
    >
      <vb-lookup-definition
        [element]="property"
        [formData]="formData"
        [isRDBMS]="showRdbmsProps"
        [pickList]="pickList"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [fieldIdMap]="fieldIdMap"
        (templateChange)="onTemplateChange($event)"
        [searchTerm]="searchTerm"
      ></vb-lookup-definition>
    </div>

    <div
      class="search-section"
      *ngIf="
        property.uiType === 'searchablefields' &&
        techStackData &&
        techStackData.textSearch === 'Elastic Search' &&
        conditionalCheck[property.name]
      "
      [formGroup]="formGroup"
    >
      <vb-search-field-settings
        [fieldIdMap]="fieldIdMap"
        [tableIdMap]="tableIdMap"
        [fsData]="fsData"
        [element]="property"
        [pickList]="pickList"
        [formData]="formData"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [dataModelOrders]="dataModelOrders"
      >
      </vb-search-field-settings>
    </div>

    <div
      class="import-section"
      *ngIf="
        property.uiType === 'importconfig' &&
        conditionalCheck[property.name] &&
        !additionalCondCheck[property.name] &&
        techStackData &&
        techStackData?.runtime !== 'GAE first Generation'
      "
      [formGroup]="formGroup"
    >
      <vb-vs-import-prop
        [element]="property"
        [formData]="formData"
        [isRDBMS]="showRdbmsProps"
        [pickList]="pickList"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [fieldIdMap]="fieldIdMap"
        [settingsData]="settingsData"
        [searchTerm]="searchTerm"
        [dataModelOrders]="dataModelOrders"
        [isBusinessRulesEnabled]="isBusinessRulesEnabled"
        (onTemplateChange)="onTemplateChange($event)"
      ></vb-vs-import-prop>
    </div>
    <div
      class="export-section"
      *ngIf="
        property.uiType === 'exportconfig' &&
        conditionalCheck[property.name] &&
        techStackData &&
        techStackData?.runtime !== 'GAE first Generation'
      "
      [formGroup]="formGroup"
    >
      <vb-vs-export-prop
        [element]="property"
        [formControlName]="property.name"
        [formData]="formData"
        [pickList]="pickList"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [fieldIdMap]="fieldIdMap"
        [searchTerm]="searchTerm"
        (onTemplateChange)="onTemplateChange($event)"
      ></vb-vs-export-prop>
    </div>
    <div *ngIf="property.uiType === 'tableacl' && conditionalCheck[property.name]" [formGroup]="formGroup">
      <vb-table-acl [formData]="formData" [tableIdMap]="tableIdMap" [disableField]="disallowEdit || isModernizeDisabled(property.name)"></vb-table-acl>
    </div>
    <div *ngIf="property.uiType === 'pagelookupconfig' && conditionalCheck[property.name]" [formGroup]="formGroup">
      <vb-pg-lookup-configuration
        [element]="property"
        [formData]="formData"
        [formControlName]="property.name"
        [currNodeType]="currNodeType"
        [currentScreen]="currentScreen"
        [currentNode]="currentNode"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [searchTerm]="searchTerm"
      ></vb-pg-lookup-configuration>
    </div>
    <div *ngIf="property.uiType === 'cudconfig' && conditionalCheck[property.name]" [formGroup]="formGroup">
<vb-cud-config [element]="property" [formData]="formData" [fsData]="fsData" [formControlName]="property.name"
        [currNodeType]="currNodeType" [currentScreen]="currentScreen" [dataModelOrders]="dataModelOrders"
        [currentNode]="currentNode" [disableField]="disallowEdit || isModernizeDisabled(property.name)"></vb-cud-config>
    </div>
    <div
      *ngIf="
        property.uiType === 'queryViewParamMapping' &&
        conditionalCheck[property.name] &&
        !additionalCondCheck[property.name]
      "
      [formGroup]="formGroup"
    >
      <vb-query-param-map
        [element]="property"
        [formData]="formData"
        [formControlName]="property.name"
        [currNodeType]="currNodeType"
        [currentScreen]="currentScreen"
        [currentNode]="currentNode"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
      >
      </vb-query-param-map>
    </div>
    <div
      *ngIf="
        property.uiType === 'runtimeConfig' && conditionalCheck[property.name] && !additionalCondCheck[property.name]
      "
    >
      <vb-runtime-config
        class="w-100"
        [formData]="formData"
        [element]="property"
        [pickList]="pickList"
        [disableField]="disallowEdit || isModernizeDisabled(property.name)"
        [settingsData]="settingsData"
        (businessRulesConfigChanged)="onBusinessRulesConfigChanged($event)"
      ></vb-runtime-config>
    </div>
    <div
      *ngIf="property.uiType === 'pageVariablesProperty' && conditionalCheck[property.name] && !isFromModernize"
      [formGroup]="formGroup"
      class="col-sm-12 input-ctrl"
    >
      <vb-page-variables-property
        [element]="property"
        [formData]="formData"
        [currNodeType]="currNodeType"
        [currentScreen]="currentScreen"
        [currentNode]="currentNode"
        [isRDBMS]="showRdbmsProps"
        [disableField]="disallowEdit"
        [isFromModernize]="isFromModernize"
      >
      </vb-page-variables-property>
    </div>
  </ng-template>
</div>

<!-- Provider Environment URL Config Dialog -->
<vb-provider-env-url-config
  [(visible)]="showEnvUrlConfigDialog"
  [environmentsData]="filteredEnvironmentsForDialog"
  [formData]="envFormDataCache"
  [disableField]="disallowEdit"
  [providerName]="formData?.name || ''"
  (save)="onEnvUrlConfigSave($event)"
></vb-provider-env-url-config>
